// @flow
import React from 'react'

type Props = {}

function Chart2(props: Props) {
  return (
    <svg
      {...props}
      viewBox="0 0 221 192"
      width={442}
      height={384}
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    >
      <path fill="none" d="M0 0h220.2v192H0z" />
      <clipPath id="a">
        <path d="M0 0h220.2v192H0z" />
      </clipPath>
      <g clipPath="url(#a)">
        <path fill="#fff" d="M0 0h220.2v192H0z" />
        <path
          d="M30.4 151.18h178.8m-178.8-17.5h178.8m-178.8-17.5h178.8M30.4 98.68h178.8M30.4 81.18h178.8M30.4 63.68h178.8M30.4 46.18h178.8M30.4 28.43h178.8M30.4 11h178.8"
          fill="none"
          stroke="#dadada"
          strokeWidth=".75"
        />
        <path
          d="M41.2 31.93h14.25V168.8H41.2V31.93zm35.75 126.25H91.2v10.62H76.95v-10.62zm35.75 1.75h14.25v8.87H112.7v-8.87zm35.75 3.5h14.25v5.37h-14.25v-5.37zm35.75 4.5h14.25v.87H184.2v-.87z"
          fill="#5b9bd5"
          fillRule="nonzero"
          stroke="#fff"
          strokeWidth="1.5"
        />
        <path
          d="M30.4 168.8h178.8M30.4 168.8v2.86m35.8-2.86v2.86m35.75-2.86v2.86m35.75-2.86v2.86m35.75-2.86v2.86m35.75-2.86v2.86"
          fill="none"
          stroke="#dadada"
          strokeWidth=".75"
        />
        <text
          x="11.2"
          y="171.48"
          fontFamily="'LucidaGrande','Lucida Grande',sans-serif"
          fontWeight="500"
          fontSize="9"
          fill="#585858"
        >
          0
          <tspan x="15.7" y="171.48">
            %
          </tspan>
        </text>
        <text
          x="6.63"
          y="153.93"
          fontFamily="'LucidaGrande','Lucida Grande',sans-serif"
          fontWeight="500"
          fontSize="9"
          fill="#585858"
        >
          1
          <tspan x="11.155px 15.68px" y="153.93px 153.93px">
            0%
          </tspan>
        </text>
        <text
          x="6.63"
          y="136.38"
          fontFamily="'LucidaGrande','Lucida Grande',sans-serif"
          fontWeight="500"
          fontSize="9.025"
          fill="#585858"
        >
          2
          <tspan x="11.155px 15.68px" y="136.38px 136.38px">
            0%
          </tspan>
        </text>
        <text
          x="6.63"
          y="118.85"
          fontFamily="'LucidaGrande','Lucida Grande',sans-serif"
          fontWeight="500"
          fontSize="9"
          fill="#585858"
        >
          3
          <tspan x="11.155px 15.68px" y="118.85px 118.85px">
            0%
          </tspan>
        </text>
        <text
          x="6.63"
          y="101.3"
          fontFamily="'LucidaGrande','Lucida Grande',sans-serif"
          fontWeight="500"
          fontSize="9.025"
          fill="#585858"
        >
          4
          <tspan x="11.155px 15.68px" y="101.3px 101.3px">
            0%
          </tspan>
        </text>
        <text
          x="6.63"
          y="83.78"
          fontFamily="'LucidaGrande','Lucida Grande',sans-serif"
          fontWeight="500"
          fontSize="9"
          fill="#585858"
        >
          5
          <tspan x="11.155px 15.68px" y="83.78px 83.78px">
            0%
          </tspan>
        </text>
        <text
          x="6.63"
          y="66.23"
          fontFamily="'LucidaGrande','Lucida Grande',sans-serif"
          fontWeight="500"
          fontSize="9"
          fill="#585858"
        >
          6
          <tspan x="11.155px 15.68px" y="66.23px 66.23px">
            0%
          </tspan>
        </text>
        <text
          x="6.63"
          y="48.71"
          fontFamily="'LucidaGrande','Lucida Grande',sans-serif"
          fontWeight="500"
          fontSize="9"
          fill="#585858"
        >
          7
          <tspan x="11.155px 15.68px" y="48.71px 48.71px">
            0%
          </tspan>
        </text>
        <text
          x="6.63"
          y="31.16"
          fontFamily="'LucidaGrande','Lucida Grande',sans-serif"
          fontWeight="500"
          fontSize="9"
          fill="#585858"
        >
          8
          <tspan x="11.155px 15.68px" y="31.16px 31.16px">
            0%
          </tspan>
        </text>
        <text
          x="6.63"
          y="13.63"
          fontFamily="'LucidaGrande','Lucida Grande',sans-serif"
          fontWeight="500"
          fontSize="9"
          fill="#585858"
        >
          9
          <tspan x="11.155px 15.68px" y="13.63px 13.63px">
            0%
          </tspan>
        </text>
        <text
          x="41.27"
          y="183.18"
          fontFamily="'LucidaGrande','Lucida Grande',sans-serif"
          fontWeight="500"
          fontSize="9"
          fill="#585858"
        >
          P
          <tspan x="45.508px 51.512px" y="183.18px 183.18px">
            DF
          </tspan>
        </text>
        <text
          x="77.37"
          y="183.18"
          fontFamily="'LucidaGrande','Lucida Grande',sans-serif"
          fontWeight="500"
          fontSize="9"
          fill="#585858"
        >
          P
          <tspan x="81.991px 86.613px" y="183.18px 183.18px">
            PT
          </tspan>
        </text>
        <text
          x="111.83"
          y="183.18"
          fontFamily="'LucidaGrande','Lucida Grande',sans-serif"
          fontWeight="500"
          fontSize="9"
          fill="#585858"
        >
          D
          <tspan x="117.46px 123.341px" y="183.18px 183.18px">
            OC
          </tspan>
        </text>
        <text
          x="145.03"
          y="183.18"
          fontFamily="'LucidaGrande','Lucida Grande',sans-serif"
          fontWeight="500"
          fontSize="9"
          fill="#585858"
        >
          H
          <tspan
            x="150.868px 155.784px 162.76px"
            y="183.18px 183.18px 183.18px"
          >
            TML
          </tspan>
        </text>
        <text
          x="185.22"
          y="183.18"
          fontFamily="'LucidaGrande','Lucida Grande',sans-serif"
          fontWeight="500"
          fontSize="9"
          fill="#585858"
        >
          X
          <tspan x="189.912px 193.77px" y="183.18px 183.18px">
            LS
          </tspan>
        </text>
      </g>
    </svg>
  )
}

export default Chart2
